import { useState, useEffect } from 'react'

const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: '23',
    minutes: '59',
    seconds: '59',
    isExpired: false,
  })

  useEffect(() => {
    const STORAGE_KEY = 'sos-reflujo-offer-start'
    let startTime = localStorage.getItem(STORAGE_KEY)

    if (!startTime) {
      startTime = Date.now().toString()
      localStorage.setItem(STORAGE_KEY, startTime)
    }

    const targetTime = parseInt(startTime, 10) + TWENTY_FOUR_HOURS

    const updateTimer = () => {
      const now = Date.now()
      const difference = targetTime - now

      if (difference <= 0) {
        setTimeLeft({
          hours: '00',
          minutes: '00',
          seconds: '00',
          isExpired: true,
        })
        return true // expired
      }

      const h = Math.floor((difference / (1000 * 60 * 60)) % 24)
      const m = Math.floor((difference / 1000 / 60) % 60)
      const s = Math.floor((difference / 1000) % 60)

      setTimeLeft({
        hours: h.toString().padStart(2, '0'),
        minutes: m.toString().padStart(2, '0'),
        seconds: s.toString().padStart(2, '0'),
        isExpired: false,
      })
      return false
    }

    // Initial call
    const isExpired = updateTimer()

    if (!isExpired) {
      const interval = setInterval(() => {
        const expired = updateTimer()
        if (expired) clearInterval(interval)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [])

  return timeLeft
}
